import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import playButton from '../../assets/play.svg'
import pauseButton from '../../assets/pause.svg'

export default class Video extends Component {

  state = {
    isPlaying: false,
    isInteracted: false
  }

  wasFirstInteraction = false

  componentWillReceiveProps (nextProps) {
    if (nextProps.focused) {
      if (!this.wasFirstInteraction) {
        this.wasFirstInteraction = true
        setTimeout(this.play, 2000)
      } else {
        this.interacted()
      }
    } else if (!nextProps.focused && this.state.isPlaying) {
      this.pause()
    }
  }

  onClick = () => {
    if (this.videoRef.currentTime > 0 && !this.videoRef.paused && !this.videoRef.ended) {
      this.pause()
    } else {
      this.play()
    }
  }

  play = () => {
    console.log('Play video')
    this.interacted()
    this.setState({ isPlaying: true })
    this.videoRef.play()
  }

  pause () {
    this.interacted()
    this.setState({ isPlaying: false })
    this.videoRef.pause()
  }

  interacted () {
    this.setState({ isInteracted: true })

    if (this.interactionTimer) clearTimeout(this.interactionTimer)

    this.interactionTimer = setTimeout(() => {
      this.setState({ isInteracted: false })
      this.interactionTimer = null
    }, 3500)
  }

  render () {
    const { isPlaying, isInteracted } = this.state
    return (
      <div
        id='aw_video__video'
        className='aw_video__video-wrapper'
        style={{ backgroundImage: `url(${this.props.videoBg})` }}
        onClick={this.onClick}
      >
        <video
          preload='none'
          loop
          muted
          playsInline
          className='aw_video__video'
          src={this.props.video}
          ref={ref => (this.videoRef = ref)}
        />
        <CSSTransitionGroup
          transitionName='aw_video__video-controls'
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}
        >
          {isInteracted &&
            <div className='aw_video__video-controls' key='video'>
              {isPlaying
                ? <img src={pauseButton} style={{ height: '8rem' }} />
                : <img src={playButton} style={{ height: '8rem' }} />
              }
            </div>
          }
        </CSSTransitionGroup>
      </div>
    )
  }

  static propTypes = {
    videoBg: PropTypes.string,
    video: PropTypes.string,
    focused: PropTypes.bool // eslint-disable-line react/no-unused-prop-types
  }
}



// WEBPACK FOOTER //
// ./src/templates/app-website/components/video/Video.js